import api from './client';
import type { Dossier } from 'types/dossier';
import type { ListParams } from './types';

export interface DocumentClassification {
  type_key: string;
  type_label: string;
  confidence: number;
  suggested_name: string;
}

export const dossiersApi = {
  list: async (params?: ListParams & { org_id?: string; type?: string; offset?: number; sort_by?: string; sort_dir?: string }): Promise<Dossier[]> => {
    const { data } = await api.get('/dossiers', { params });
    return data;
  },

  get: async (id: string): Promise<Dossier> => {
    const { data } = await api.get(`/dossiers/${id}`);
    return data;
  },

  create: async (dossier: Omit<Dossier, 'id'>): Promise<Dossier> => {
    const { data } = await api.post('/dossiers', dossier);
    return data;
  },

  update: async (id: string, updates: Partial<Dossier>): Promise<Dossier> => {
    const { data } = await api.patch(`/dossiers/${id}`, updates);
    return data;
  },

  delete: async (id: string): Promise<void> => {
    await api.delete(`/dossiers/${id}`);
  },

  uploadDocument: async (dossierId: string, file: File, name?: string, documentType?: string): Promise<Dossier> => {
    const formData = new FormData();
    formData.append('file', file);
    if (name) formData.append('name', name);
    if (documentType) formData.append('document_type', documentType);
    const { data } = await api.post(`/dossiers/${dossierId}/documents`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return data;
  },

  getDocumentUrl: async (dossierId: string, documentId: string): Promise<string> => {
    const { data } = await api.get(`/dossiers/${dossierId}/documents/${documentId}/url`);
    return data.url;
  },

  classifyDocument: async (file: File): Promise<DocumentClassification> => {
    const formData = new FormData();
    formData.append('file', file);
    const { data } = await api.post('/dossiers/documents/classify', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return data;
  },
};
